<template>
    <div class="notice-main">
        <el-row type="flex">
            <el-col :span="21">
                <el-row>
                    <el-col class="notice-main-item">
                        <el-input
                            :placeholder="$translate('lang.E3202103170007', { defaultText: '标题' })"
                            @keyup.enter.native="handleLogin"
                            v-model="queries.subject">
                        </el-input>
                    </el-col>
                    <el-col class="notice-main-item">
                        <el-select v-model="queries.state" placeholder="维护类型" style="width:100%" clearable >
                            <el-option :label="$translate('lang.E3202103170010', { defaultText: '最新公告' })" value="1"></el-option>
                            <el-option :label="$translate('lang.E3202103170009', { defaultText: '常见问题' })" value="2"></el-option>
                            <el-option label="内销公告" value="3"></el-option>
                            <el-option label="外销公告" value="4"></el-option>
                        </el-select>
                    </el-col>
                    <el-col class="notice-main-item">
                        <el-date-picker
                            v-model="timeHorizon"
                            class="notice-search-input-date"
                            type="daterange"
                            align="left"
                            value-format='yyyy-MM-dd HH:mm:ss'
                            :default-time="['00:00:00', '23:59:59']"
                            unlink-panels
                            range-separator="-"
                            :start-placeholder="$translate('lang.E3202101270023', { defaultText: '开始日期' })"
                            :end-placeholder="$translate('lang.E3202101270024', { defaultText: '结束日期' })"
                            size="mini"
                            :picker-options="pickerOptions">
                        </el-date-picker>
                    </el-col>
                    <div>
                        <el-button @click="handleLogin" type="primary" size="mini" icon='el-icon-search'>
                            {{$translate('lang.E3202101260004', { defaultText: '查 询' })}}
                        </el-button>
                        <el-button class="sn-search-reset-button" @click="reset" size="mini">
                            {{$translate('lang.E3202101260009', { defaultText: '重 置' })}}
                        </el-button>
                    </div>
                </el-row>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import formatTime from '@/utils/common.js';
export default {
    data() {
        return {
            timeHorizon: [],
            queries: {
                subject: '',
                state: '2'
            },
            pickerOptions: {
                shortcuts: [
                    {
                        text: this.$translate('lang.E3202101270017', { defaultText: '最近一周' }),
                        onClick(picker) {
                            picker.$emit('pick', [formatTime.initStartDate(6), formatTime.initEndDate()]);
                        }
                    },
                    {
                        text: this.$translate('lang.E3202101270019', { defaultText: '最近一个月' }),
                        onClick(picker) {
                            picker.$emit('pick', [formatTime.initStartDate(30), formatTime.initEndDate()]);
                        }
                    },
                    {
                        text: this.$translate('lang.E3202101270021', { defaultText: '最近三个月' }),
                        onClick(picker) {
                            picker.$emit('pick', [formatTime.initStartDate(90), formatTime.initEndDate()]);
                        }
                    }
                ]
            }
        };
    },
    methods: {
        // 初始化搜索框-时间
        getTime () {
            this.timeHorizon[0] = formatTime.formatDate(formatTime.initStartDate(29)) + ' 00:00:00';
            this.timeHorizon[1] = formatTime.formatDate(formatTime.initEndDate()) + ' 23:59:59';
        },
        handleLogin() {
            this.$emit('closeChange', this.queries);
        },
        reset() {
            this.timeHorizon = [];
            this.getTime();
            this.queries.subject = '';
            this.queries.state = '2';
        }
    },
    created() {
        this.getTime();
    }
};
</script>
<style lang="less">
.notice-main{
    margin-bottom: 20px;
    .notice-main-item{
        width: 190px;
        margin-right: 10px;
        .notice-search-input-date{
            width: 100%;
            .el-range__icon {
                display: none;
            }
        }
    }
}
</style>